import React from 'react'

export default function InfoSection({ sectionLabel, children, fullWidth }) {
  return (
    <div style={{ marginBottom: "16px", flex: `0 0 ${fullWidth ? '100%' : '48%'}` }}>
      {sectionLabel && (
        <h6 style={{ color: "grey", margin: 0 }}>{sectionLabel}</h6>
      )}
      <div style={{ marginTop: "8px" }}>{children}</div>
    </div>
  )
}
